// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__9nP-x","loaderOuter":"PageOverlayLoader_loaderOuter__1NhJB"};